import * as React from 'react';

export default () => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="12"
          viewBox="0 0 12 12"
        >
          <path d="M10.245 1.756a6.009 6.009 0 00-8.487 0A5.964 5.964 0 000 6c0 1.603.624 3.11 1.758 4.243A5.983 5.983 0 006 11.998a5.983 5.983 0 004.244-1.755 6.008 6.008 0 000-8.487zm-.657 7.83a5.078 5.078 0 01-7.173 0A5.039 5.039 0 01.93 6a5.04 5.04 0 011.485-3.587 5.078 5.078 0 017.173 0 5.078 5.078 0 010 7.173z"></path>
          <path d="M8.005 7.285L6.688 5.971l1.317-1.314a.466.466 0 00-.658-.658L6.03 5.314 4.713 3.999a.465.465 0 10-.657.658L5.372 5.97 4.056 7.285a.465.465 0 10.657.658L6.03 6.628l1.317 1.315a.463.463 0 00.658 0 .465.465 0 000-.658z"></path>
        </svg>
    );
}